import { XIcon as FooterXIcon } from '@kijiji/icons/src/icons'
import FooterAppStoreIcon from '@kijiji/icons/src/icons/FooterAppStore'
import FooterAppStoreFrIcon from '@kijiji/icons/src/icons/FooterAppStoreFr'
import FooterFacebookIcon from '@kijiji/icons/src/icons/FooterFacebook'
import FooterGooglePlayIcon from '@kijiji/icons/src/icons/FooterGooglePlay'
import FooterGooglePlayFrIcon from '@kijiji/icons/src/icons/FooterGooglePlayFr'
import FooterInstagramIcon from '@kijiji/icons/src/icons/FooterInstagram'
import FooterKijijiCentralIcon from '@kijiji/icons/src/icons/FooterKijijiCentral'
import FooterYoutubeIcon from '@kijiji/icons/src/icons/FooterYoutube'
import { theme } from '@kijiji/theme'
import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const SOCIALS_BG_COLORS = {
  facebook: '#3c5b9a',
  instagram:
    'linear-gradient(197deg, rgba(131,58,180,1) 0%, rgba(255,90,90,1) 54%, rgba(252,176,69,1) 86%, rgba(252,208,69,1) 100%)',
  x: '#000000',
  youtube: '#e91c00',
  kijijicentral: theme.colors.green.primary,
}

type SOCIAL_KEYS = keyof typeof SOCIALS_BG_COLORS

export const BadgesContainer = styled.div(
  ({ theme }) => `
    margin-top: 6rem;

    ${MEDIA_QUERIES(theme).mediumSmall} {
      margin: 0;
    }

    ${MEDIA_QUERIES(theme).medium} {
      align-items: center;
      display: flex;
      justify-content: center;
    }
  `
)

export const StoreIconsContainer = styled.div(
  ({ theme }) => `
    display: flex;
    justify-content: space-evenly;
    margin: 0 2.5rem;

    ${MEDIA_QUERIES(theme).medium} {
      margin: 0 0 0 2rem;

      & a:last-of-type {
        margin-left: 3.5rem;
      }
    }
  `
)

export const AppStoreIcon = styled(FooterAppStoreIcon)(
  () => `
    height: 4.5rem;
    width: 13.5rem;
    &:hover, &:focus {
      & > path:first-of-type {
        fill: ${theme.colors.grey.light2};
      }
    },
  `
)

export const AppStoreIconFr = styled(FooterAppStoreFrIcon)(
  () => `
    height: 4.5rem;
    width: 13.5rem;
    &:hover, &:focus {
      & > path:first-of-type {
        fill: ${theme.colors.grey.light2};
      }
    },
  `
)

export const PlayStoreIcon = styled(FooterGooglePlayIcon)(
  () => `
    height: 4.5rem;
    width: 13.5rem;
    &:hover, &:focus {
      & > path:first-of-type {
        fill: ${theme.colors.grey.light2};
      }
    },
  `
)

export const PlayStoreIconFr = styled(FooterGooglePlayFrIcon)(
  () => `
    height: 4.5rem;
    width: 13.5rem;
    &:hover, &:focus {
      & > path:first-of-type {
        fill: ${theme.colors.grey.light2};
      }
    },
  `
)

export const SocialIconsContainer = styled.div(
  ({ theme }) => `
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 3rem auto 0 auto;
    width: 18rem;

    ${MEDIA_QUERIES(theme).mediumSmall} {
      width: auto;
    }

    ${MEDIA_QUERIES(theme).medium} {
      margin: 0 0 0 5rem;
    }
  `
)

// eslint-disable-next-line @kijiji/prefer-link-custom
export const SocialIcon = styled.a<{ $socialType: SOCIAL_KEYS }>(
  ({ theme, $socialType }) => `
    border-radius: ${theme.borderRadius.xLarge};
    align-items: center;
    background-color: ${theme.colors.grey.light1};
    display: inline-block;
    height: 5rem;
    justify-content: center;
    margin-left: 1.5rem;
    position: relative;
    width: 5rem;

    & svg {
      left: 50%;
      position: absolute;
      top: 50%;
    }

    &:first-child {
      margin-left: 0;
    }

    &:hover, &:focus {
      background: ${SOCIALS_BG_COLORS[$socialType] || theme.colors.green.primary}
    },
  `
)

export const SocialsGroupB = styled.div`
  margin: 1rem auto 0 auto;

  ${MEDIA_QUERIES(theme).mediumSmall} {
    margin: 0 0 0 1.5rem;
  }
`

export const FacebookIcon = styled(FooterFacebookIcon)(
  ({ theme }) => `
    color: ${theme.colors.white};
    height: 2rem;
    width: 1rem;
    margin-left: -0.5rem;
    margin-top: -1rem;
  `
)

export const InstagramIcon = styled(FooterInstagramIcon)(
  ({ theme }) => `
    color: ${theme.colors.white};
    height: 2.2rem;
    width: 2.2rem;
    margin-left: -1.1rem;
    margin-top: -1.1rem;
  `
)

export const XIcon = styled(FooterXIcon)(
  ({ theme }) => `
    color: ${theme.colors.white};
    height: 2rem;
    width: 2rem;
    margin-left: -1rem;
    margin-top: -1rem;
  `
)

export const KijijiCentralIcon = styled(FooterKijijiCentralIcon)(
  ({ theme }) => `
    color: ${theme.colors.white};
    height: 2.5rem;
    width: 2.5rem;
    margin-left: -1.25rem;
    margin-top: -1.25rem;
  `
)

export const YoutubeIcon = styled(FooterYoutubeIcon)(
  ({ theme }) => `
    color: ${theme.colors.white};
    height: 1.8rem;
    width: 2.5rem;
    margin-left: -1.25rem;
    margin-top: -0.9rem;
  `
)
